import { Grid, Box, Card, useTheme } from '@material-ui/core'
import React, { useRef, useState, useContext } from 'react'
import { components } from 'cng-web-lib'
import Stepper from '../../../components/aciacehighway/Stepper'
import VesselDepartureEditForm from './VesselDepartureEditPage'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import { useParams } from 'react-router-dom'
import ResponseMessage from './response/ResponseMessage'
import { ACEOceanTranslationContext } from '../contexts/ACEOceanTranslationContext'

const {
  form: { CngAddForm }
} = components

function AddPage({ history, loading, location, showNotification, onSetLoading }) {

  const { id } = useParams()

  const { state } = location

  const vesselDepartureData = useRef(state?.vesselDepartureData || null)
  const [vesselDepartureStatus, setVesselDepartureStatus] = useState(null)
  const [step, setStep] = useState((state?.step ? state.step : 1) - 1)
  const [completed, setCompleted] = useState({})
  const [stepIconColor, setStepIconColor] = useState({})
  const theme = useTheme()
  const { getTranslatedText } = useContext(ACEOceanTranslationContext)

  function renderContent(step) {
    switch (step) {
      case 0:
        return (
          <VesselDepartureEditForm
            id={id}
            vesselDepartureData={vesselDepartureData}
            onChangeStep={(step) => setStep(step)}
            onSetVesselDepartureStatus={setVesselDepartureStatus}
            history={history}
            showNotification={showNotification}
            onSetLoading={onSetLoading}
            step={step}
          />)
      case 1:
        return (
          <ResponseMessage
            showNotification={showNotification}
            id={id}
            isViewOnly={true}
          />
        )
    }
  }

  return (
    <>
      <Card>
        <Stepper
          steps={!vesselDepartureStatus || vesselDepartureStatus === 'DR' ? [getTranslatedText("VESSEL_DEPARTURE","createVesselDepartureTab")] : [getTranslatedText("VESSEL_DEPARTURE","createVesselDepartureTab"), getTranslatedText("VESSEL_DEPARTURE","viewVesselDepartureResponseTab")]}
          activeStep={step}
          completed={completed}
          onSetActiveStep={(step) => setStep(step)}
          stepIconColor={stepIconColor}
        />
        <Box
          padding={2}
          style={{ backgroundColor: theme.palette.background.sectionOddBg }}
        >
          {renderContent(step)}
        </Box>
      </Card>
    </>
  )

}

export default withFormState(AddPage)
